import React from 'react';
import Radium from 'radium';

import ProductList from 'views/product/ProductList';
import HeaderBanner from 'views/HeaderBanner';

const SuggestedProducts = Radium((props) => {
	const products = props.products;
	const filterProduct = props.filterProduct;
	
	if(!products)
		return null;

	const suggestedProducts = products.filter(p => {
		if(filterProduct)
			return p.id !== filterProduct.id;
		
		return true;
	}).sort(() => .5 - Math.random());

	
    if(!suggestedProducts || suggestedProducts.length === 0)
		return null;
		
	return <div className="suggestedProducts" style={{margin: '0 15px'}}>
				
				<h2 style={{color: 'darkcyan', paddingTop: '10px', borderTop: '1px solid gray'}}>{props.title || 'You May Also Like!'}</h2>

				<ProductList products={suggestedProducts} showSlider={true} 
							autoplay={props.autoplay} navigator={props.navigator} 
							flattenProductImages={true} />
				
			</div>
});


export default SuggestedProducts;


// WEBPACK FOOTER //
// ./src/views/product/SuggestedProducts.js